import { css } from '@emotion/react';
import { Stack, Typography } from '@mui/material';
import { motion } from 'motion/react';
import { useAtomValue } from 'jotai';
import { useMemo } from 'react';
import { GenericFallbacksWrapper } from '../../../components/Fallback/GenericFallbacksWrapper';
import { FundWaterfallType } from '../../../schemas/ClientConfig.schema';
import { getFundWaterfallType } from '../../../services/state/AppConfigStateJ';
import { colors } from '../../../theme/colors';
import { cardStyles } from '../../../theme/component-styles';
import { isEditingFundDataState, selectedFundIdStateFP } from '../state/FPState';
import { EditFundData } from './EditFundData';
import { FundDataHistory } from './FundDataHistory';
import { WaterfallModellingGrid } from './WaterfallModellingGrid2';
import { WaterfallModellingGrid3 } from './WaterfallModellingGrid3';
import { WaterfallSettings, WaterfallSettingsToggle } from './WaterfallSettings';
import { WaterfallConfigToggles } from './WaterfallConfigToggles';

const Card = css({
  ...cardStyles,
});

const MainContent = css`
  ${Card};
  padding: 1rem;
  &.editing {
    border-left: 4px solid ${colors.secondary[40]};
  }
`;

export function WaterfallModelling() {
  const fundId = useAtomValue(selectedFundIdStateFP);
  const isEditingFundData = useAtomValue(isEditingFundDataState);
  const isFormulaBased = getFundWaterfallType() === FundWaterfallType.FormulaBased;

  const gridComponent = useMemo(() => {
    if (isFormulaBased) {
      return <WaterfallModellingGrid3 />;
    }
    return <WaterfallModellingGrid />;
  }, [isFormulaBased]);

  if (!fundId) {
    return null;
  }
  return (
    <GenericFallbacksWrapper>
      <Stack display='grid' gridTemplateColumns={'auto 1fr auto'} gap='0.5rem' alignItems={'center'}>
        <WaterfallSettingsToggle />
        <Typography variant='subtitle1'>Waterfall Modelling</Typography>
        {isFormulaBased && <WaterfallConfigToggles />}
      </Stack>
      <Stack display={'grid'} gridTemplateColumns={'min-content 1fr'} mt='0.5rem'>
        <GenericFallbacksWrapper>
          <WaterfallSettings />
        </GenericFallbacksWrapper>
        <div css={MainContent} className={isEditingFundData ? 'editing' : ''} key={String(isEditingFundData)}>
          <motion.div
            animate={{ opacity: [0, 1] }}
            transition={{ duration: 0.5 }}
            key={String(isEditingFundData)}
          >
            {isEditingFundData ? (
              <>
                <EditFundData fundId={fundId} />
                <FundDataHistory fundId={fundId} />
              </>
            ) : (
              gridComponent
            )}
          </motion.div>
        </div>
      </Stack>
    </GenericFallbacksWrapper>
  );
}
